import getConfig from 'next/config';

import { ObjectFromEntries } from './index';

const {
  publicRuntimeConfig: { isProd },
} = getConfig();
import { EVENTS } from './index';

export const logEventGTM = async (data = {}) => {
  const dataLayer = {
    // added pageCategory and url for all event of GTM
    loginStatus: window.isLoggedIn || false,
    category: window.pageCategory,
    url: window.location.pathname,
    ...data,
  };
  if (!isProd) {
    console.info(dataLayer);
  }

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push(dataLayer);
};

/**
 * Dispatch custom event to GTM
 * @param eventName
 * @param label
 * @param action
 */
export const logCustomGTMEvent = (eventName, label, action) => {
  const event = document.createEvent('CustomEvent');
  const options = {
    category: window.pageCategory,
    ...(label && { label }),
    ...(action && { action }),
  };
  if (event) {
    event.initCustomEvent(eventName, false, false, options);
    document.dispatchEvent(event);
  }
};

export const getSurveyGtmSourceName = (data = {}) => {
  const { survey, pageCategory = window ? window.pageCategory : '', utm_campaign } = data;
  if (
    survey === '037' ||
    survey === '032' ||
    survey === '038' ||
    (survey === '036' && pageCategory === 'Home' && utm_campaign !== 'nav_sign_up')
  ) {
    return 'Location Survey Flow';
  }
  if (survey === '033') {
    return 'Add To My Jobs Survey Flow';
  }
  if (survey === '034') {
    return 'Job Type Survey Flow';
  }
  if (survey === '035') {
    return 'States Survey Flow';
  }
  if (survey === '036') {
    return 'Header Sign Up Survey Flow';
  }
  return '';
};

export const getReviewGtmSourceName = (source) => {
  if (source === 'cpp-add-review-button') {
    return 'Add Review Button';
  }
  if (source === 'cpp-stars-review-box') {
    return 'On Page Box';
  }
  if (source === 'reviews-review-box') {
    return 'On Page Form';
  }
  if (source === 'cpp-stars-ranking') {
    return 'Stars Ranking';
  }
  if (source === 'cpp-thumbs-up') {
    return 'Thumbs Up';
  }
  if (source === 'cpp-thumbs-down') {
    return 'Thumbs Down';
  }
  return '';
};

export const gtmLogResumeUploadEvent = (source) => {
  if (!source) {
    let payload = {};
    if (window && window.location) {
      payload = ObjectFromEntries(new URLSearchParams(location.search));
    }
    source = getSurveyGtmSourceName(payload);
  }
  logEventGTM({
    event: 'Resume Upload',
    ...(source && { resumeUploadSource: source }),
  });
};

export const gtmLogSignupEvent = (source) => {
  if (!source) {
    let payload = {};
    if (window && window.location) {
      payload = ObjectFromEntries(new URLSearchParams(location.search));
    }
    source = getSurveyGtmSourceName(payload);
  }
  logEventGTM({
    event: 'Successful Email Submission',
    ...(source && { signupSource: source }),
  });
};

export const gtmLogViewedSurveyStep = () => {
  setTimeout(() => {
    let payload = {};
    if (window && window.location) {
      payload = ObjectFromEntries(new URLSearchParams(location.search));
    }

    const { survey_step = '', survey = '', src = '' } = payload || {};

    logEventGTM({
      event: 'Viewed Survey Step',
      surveyName: survey,
      surveyStep: survey_step,
      surveySource: src,
    });
  }, 200);
};

export const gtmLogCompanyReviewSubmitEvent = (source) => {
  let companyReviewSubmitSource = getReviewGtmSourceName(source);
  if (!source) {
    // // if no source specified - review submitted from survey
    let payload = {};
    if (window && window.location) {
      payload = ObjectFromEntries(new URLSearchParams(location.search));
    }
    companyReviewSubmitSource = getSurveyGtmSourceName(payload);
    source = 'survey-company-review';
  }
  logEventGTM({
    event: 'Opened Review Form Submit',
    source,
    ...(companyReviewSubmitSource && { companyReviewSubmitSource }),
  });
};

export const gtmEventForFieldSelect = (fieldName) => {
  var evt = document.createEvent('CustomEvent');
  evt.initCustomEvent(EVENTS.profileField, false, false, {
    category: 'Profile',
    action: 'Profile Field saved',
    label: 'Profile Field saved ' + fieldName,
  });
  document.dispatchEvent(evt);
};
